import { render } from "./IconHelpCircle.vue.js?vue&type=template&id=00230566!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconHelpCircle.vue?vue&type=template&id=00230566"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__